import { logger } from "@formant/core/common/logger";

import { IRtcStreamMessage } from "../models/IRtcStreamMessage";
import { IRtcStreamMessageChunk } from "../models/IRtcStreamMessageChunk";

export function reassembleMessageChunks(
    chunks: IRtcStreamMessageChunk[],
): IRtcStreamMessage | undefined {
    const encodedMessage = chunks
        .sort((a, b) => (a.seq < b.seq ? -1 : 1))
        .map(_ => _.part)
        .reduce((a, b) => a + b);
    try {
        return JSON.parse(encodedMessage);
    } catch {
        logger.warn("Could not reassemble RTC message chunks");
        return;
    }
}
